export const SSO_TYPE = {
  DEALER: 'dealer',
  LENDER: 'lender',
} as const;
